import React from "react";
import { FaMinusCircle } from "react-icons/fa";

import { TagInput, TagInputType } from "../../../../../../Components/TagInput/TagInput";

interface CommandCustomInputProps {
  index: number;
  commandKey: string;
  result: string;

  onChange(event: any): void;
  deleteValue(arrayName: string, index: number): void;
  arrayName: string;
}

export default class CommandCustomInput extends React.Component<CommandCustomInputProps> {
  constructor(props: CommandCustomInputProps) {
    super(props);
    this.deletePressed = this.deletePressed.bind(this);
  }

  deletePressed() {
    var arrayName = this.props.arrayName;
    this.props.deleteValue(arrayName, this.props.index);
  }

  render() {
    var index = this.props.index;
    var commandKeyName = "custom." + index + ".commandKey";
    var resultsName = "custom." + index + ".result";
    return (
      <div className="customInput">
        <div className="customKeyDropdown">
          <TagInput
            label="Key"
            type={TagInputType.SingleLine}
            value={this.props.commandKey}
            onChange={this.props.onChange}
            name={commandKeyName}
            placeholder="Key..."
          />
          {/*
          <UserVariablesDropdown
            allowTextInput={true}
            userVariables={this.props.userVariables}
            entities={this.props.entities}
            showEntities={true}
            onChange={this.props.onChange}
            name={commandKeyName}
            value={this.props.commandKey}
            currentVal={this.props.commandKey}
            hideNone={true}/> */}
        </div>

        <div className="customValueDropdown">
          <TagInput
            label="Value"
            type={TagInputType.SingleLine}
            value={this.props.result}
            onChange={this.props.onChange}
            name={resultsName}
            placeholder="Value..."
          />

          {/* <UserVariablesDropdown
            allowTextInput={true}
            userVariables={this.props.userVariables}
            entities={this.props.entities}
            showEntities={true}
             onChange={this.props.onChange}
             name={resultsName}
             value={this.props.result}
             currentVal={this.props.result}
             hideNone={true} /> */}
        </div>

        <span className="deleteButtonIcon mb-2 block cursor-pointer" onClick={this.deletePressed}>
          – DELETE PAIR
        </span>
      </div>
    );
  }
}
